import { AxiosResponse } from 'axios';
import {
  IEnrollmentPolicyResponse,
  IEnrollmentPolicyResponseById,
  IEnrollmentPolicyQueryParams,
} from '../../interface/enrollmentPolicy.interface';
import api from '../api';

const fetchEnrollmentPolicies = async (
  params?: IEnrollmentPolicyQueryParams,
): Promise<AxiosResponse<IEnrollmentPolicyResponse>> => {
  const res: AxiosResponse<IEnrollmentPolicyResponse> = await api.get('/enrollment-policies', {
    params,
  });
  return res;
};

const fetchEnrollmentPolicy = async (
  policyId: string,
): Promise<AxiosResponse<IEnrollmentPolicyResponseById>> => {
  const res: AxiosResponse<IEnrollmentPolicyResponseById> = await api.get(
    `/enrollment-policies/${policyId}`,
  );
  return res;
};

export const enrollmentPolicyService = {
  fetchEnrollmentPolicies,
  fetchEnrollmentPolicy,
};
